import React from "react";

const Title = () => {
  return <>Vouchers Ext</>;
};

export default Title;
